var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeambookLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 22,
    viewBox: "0 0 34 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_3545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5602 0.285156C32.7991 0.285156 33.5077 1.10109 33.5077 2.52841V4.36116C33.5077 5.78756 32.7991 6.60074 31.5602 6.60074H25.0085C23.7696 6.60074 23.061 5.78756 23.061 4.36116V2.52841C23.061 1.10109 23.7696 0.285156 25.0085 0.285156H31.5602Z",
    fill: "#7FA6CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0299 0.285156C21.2688 0.285156 21.9774 1.10109 21.9774 2.52841V4.36116C21.9774 5.78756 21.2688 6.60074 20.0299 6.60074H13.4782C12.2393 6.60074 11.5308 5.78756 11.5308 4.36116V2.52841C11.5308 1.10109 12.2393 0.285156 13.4782 0.285156H20.0299Z",
    fill: "#4C549F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0299 7.67188C21.2688 7.67188 21.9774 8.48781 21.9774 9.91513V11.7479C21.9774 13.1743 21.2688 13.9875 20.0299 13.9875H13.4782C12.2393 13.9875 11.5308 13.1743 11.5308 11.7479V9.91513C11.5308 8.48781 12.2393 7.67188 13.4782 7.67188H20.0299Z",
    fill: "#7FA6CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49957 0.285156C9.73846 0.285156 10.447 1.10109 10.447 2.52841V4.36116C10.447 5.78756 9.73846 6.60074 8.49957 6.60074H1.94745C0.708564 6.60074 0 5.78756 0 4.36116V2.52841C0 1.10109 0.708564 0.285156 1.94745 0.285156H8.49957Z",
    fill: "#7FA6CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49957 15.0605C9.73846 15.0605 10.447 15.8746 10.447 17.3015V19.1333C10.447 20.5602 9.73846 21.3743 8.49957 21.3743H1.94785C0.707765 21.3743 0 20.5607 0 19.1338V17.302C0 15.8751 0.707765 15.061 1.94785 15.061H8.49957V15.0605Z",
    fill: "#7FA6CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49957 7.67383C9.73846 7.67383 10.447 8.48976 10.447 9.91662V11.7485C10.447 13.1735 9.73846 13.9894 8.49957 13.9894H1.94785C0.707765 13.9894 0 13.1735 0 11.7485V9.91662C0 8.48976 0.707765 7.67383 1.94785 7.67383H8.49957Z",
    fill: "#4C549F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_3545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.592,
    height: 21.4286,
    fill: "white",
    transform: "translate(0 0.285156)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeambookLogo);
export default __webpack_public_path__ + "static/media/teambook_logo.30e81b54bd544ac559c0c1c792989e82.svg";
export { ForwardRef as ReactComponent };